import { render, staticRenderFns } from "./ttshop_invoice.vue?vue&type=template&id=64c67732&scoped=true&"
import script from "./ttshop_invoice.vue?vue&type=script&lang=js&"
export * from "./ttshop_invoice.vue?vue&type=script&lang=js&"
import style0 from "./ttshop_invoice.vue?vue&type=style&index=0&id=64c67732&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c67732",
  null
  
)

export default component.exports